import { render, staticRenderFns } from "./promocode-update.vue?vue&type=template&id=754bb1fc"
import script from "./promocode-update.vue?vue&type=script&lang=js"
export * from "./promocode-update.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports